/**
 * Quantas pessoas cada público de campanha alcança agora.
 *
 * Saiu do adaptador para poder ser testado sem banco — e porque "todos os
 * pacientes" contava só quem tinha data de nascimento cadastrada: a clínica
 * com metade das fichas sem nascimento via o público pela metade.
 */

import type { Campanha, PublicoDaCampanha } from './tipos';

export interface DadosDosPublicos {
    /** Quantos estão sem retorno — a mesma regra da lista (`retornos.ts`). */
    semRetorno: number;
    /** Datas de nascimento conhecidas, `YYYY-MM-DD`. */
    nascimentos: string[];
    totalPacientes: number;
    /** `situacao` é a coluna `leads.etapa` do banco desde a 0100: aberta, ganho ou perdido. */
    leads: { origem: string; situacao: string }[];
    /** Mês de referência, `YYYY-MM`. */
    mes: string;
}

export function tamanhoDoPublico(tipo: PublicoDaCampanha, param: Campanha['publicoParam'], d: DadosDosPublicos): number {
    if (tipo === 'sem-retorno') return d.semRetorno;
    if (tipo === 'aniversariantes') return d.nascimentos.filter((n) => n.slice(5, 7) === d.mes.slice(5, 7)).length;
    if (tipo === 'por-origem') {
        return d.leads.filter((l) => l.origem === param.origem && l.situacao === 'aberta').length;
    }
    return d.totalPacientes;
}
